import * as React from "react";
import { FormControl, FormHelperText, Input, InputLabel } from "../widget";
import { RxFormField } from "../../rx-form";
import { isDefined } from "../../utils";


export interface DateInputProps extends RxFormField {
    autoFocus?: boolean;
    fullWidth?: boolean;
}

class DateInput extends React.PureComponent<DateInputProps> {

    render() {

        const { fullWidth, autoFocus, ...field } = this.props;
        const helperTextId = (field.note || field.error) ? `${field.id}-text` : undefined;
        const hasError = field.touched && isDefined(field.error);
        const helperText = hasError ? field.error : field.note;

        return <FormControl fullWidth={fullWidth} error={hasError} aria-describedby={helperTextId}>
            {<InputLabel shrink htmlFor={field.id}>{field.label}</InputLabel>}
            <Input autoFocus={autoFocus} name={field.name} id={field.id} value={field.value || ''} onChange={field.onChange} onBlur={field.onBlur} placeholder={field.placeholder} />
            {helperText && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
        </FormControl>;
    }
}

export default DateInput;
